/* tslint:disable */
import { Injectable } from '@angular/core';
import { HttpClient, HttpRequest, HttpResponse, HttpHeaders } from '@angular/common/http';
import { BaseService as __BaseService } from '../base-service';
import { ApiConfiguration as __Configuration } from '../api-configuration';
import { StrictHttpResponse as __StrictHttpResponse } from '../strict-http-response';
import { Observable as __Observable } from 'rxjs';
import { map as __map, filter as __filter } from 'rxjs/operators';

import { ShareBuyback } from '../models/share-buyback';
@Injectable({
  providedIn: 'root',
})
class ShareBuybackService extends __BaseService {
  static readonly getShareBuybackByCompanyIdPath = '/shareBuyBack/{companyId}';

  constructor(
    config: __Configuration,
    http: HttpClient
  ) {
    super(config, http);
  }

  /**
   * @param companyId Id of the company for which share buybacks are required.
   * @return We will have list of trades in which the share buyback was done by the given gvkey.
   */
  getShareBuybackByCompanyIdResponse(companyId: number): __Observable<__StrictHttpResponse<Array<ShareBuyback>>> {
    let __params = this.newParams();
    let __headers = new HttpHeaders();
    let __body: any = null;

    let req = new HttpRequest<any>(
      'GET',
      this.rootUrl + `/shareBuyBack/${encodeURIComponent(String(companyId))}`,
      __body,
      {
        headers: __headers,
        params: __params,
        responseType: 'json'
      });

    return this.http.request<any>(req).pipe(
      __filter(_r => _r instanceof HttpResponse),
      __map((_r) => {
        return _r as __StrictHttpResponse<Array<ShareBuyback>>;
      })
    );
  }
  /**
   * @param companyId Id of the company for which share buybacks are required.
   * @return We will have list of trades in which the share buyback was done by the given gvkey.
   */
  getShareBuybackByCompanyId(companyId: number): __Observable<Array<ShareBuyback>> {
    return this.getShareBuybackByCompanyIdResponse(companyId).pipe(
      __map(_r => _r.body as Array<ShareBuyback>)
    );
  }
}

module ShareBuybackService {
}

export { ShareBuybackService }
